import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

let routerList = []
function importAll (r) {
  r.keys().forEach(key => {
    routerList = routerList.concat(r(key).default)
  })
}
importAll(require.context('./modules/', true, /\.routes\.js/))
/* global buildChannel */
export default new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  base: buildChannel,
  routes: [...routerList],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})
